module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_banco_tokyo.cda54c28.jpg";